import { render, staticRenderFns } from "./sdkTest.vue?vue&type=template&id=2805e752"
import script from "./sdkTest.vue?vue&type=script&lang=js"
export * from "./sdkTest.vue?vue&type=script&lang=js"
import style0 from "./sdkTest.vue?vue&type=style&index=0&id=2805e752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports